import React from 'react'
import styled from 'styled-components'
import {_L, useLocaleState} from '../../context/LocaleContext'

const ToggleButton = ({value, onChange, labels = [], compact = true}) => {
  const localeState = useLocaleState()

  if (labels.length === 0) {
    labels = [_L({key: 'No', localeState}), _L({key: 'Yes', localeState})]
  }

  const [offLabel, onLabel] = labels

  return (
    <Container compact={compact}>
      <StyledToggleButton
        value={!value}
        onClick={() => onChange(false)}
        compact={compact}
      >
        {offLabel}
      </StyledToggleButton>
      <StyledToggleButton
        value={value}
        onClick={() => onChange(true)}
        compact={compact}
      >
        {onLabel}
      </StyledToggleButton>
    </Container>
  )
}

export default ToggleButton

const Container = styled.div`
  display: flex;
  width: ${props => (props.compact ? '150px' : '100%')};
  justify-content: ${props => (props.compact ? 'flex-start' : 'space-between')};
  height: 46px;
  border-radius: 6px;
  background-color: ${props => (props.compact ? '#f3f5fb' : 'none')};
  letter-spacing: -0.3px;
  color: #a4a9b7;
  cursor: pointer;
`
const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => (props.compact ? '50%' : '120px')};
  height: 100%;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  border-radius: 6px;
  border: none;
`

const StyledToggleButton = styled(StyledButton)`
  background-color: ${props => (props.value ? '#ffffff' : '#f3f5fb')};
  box-shadow: ${props =>
    props.value ? '0 2px 6px 0 rgba(51, 149, 254, 0.38)' : 'none'};
  font-weight: ${props => (props.value ? 'bold' : 'normal')};
  color: ${props => (props.value ? '#3395fe' : '#a4a9b7')};
`
